export default "__VITE_ASSET__BAtGOkxR__"